export default {
  CANCEL: 'CANCEL',
  CONFIRM: 'CONFIRM',
  COPY: 'COPY',
  NO: 'NO',
  SAVE: 'SAVE',
  YES: 'YES',
};
